export default "__VITE_ASSET__9b7dcbb8__"